import React from 'react';
import { UserPlus, Building2, GraduationCap, BookOpen, ArrowRight } from 'lucide-react';
const targets = [{
  icon: GraduationCap,
  title: 'Residentes de Psiquiatría',
  desc: 'Respuestas rápidas y protocolos claros desde tu primer turno.'
}, {
  icon: Building2,
  title: 'Psiquiatras Hospital Público',
  desc: 'Sistematizá tu práctica y reducí tu exposición legal.'
}, {
  icon: UserPlus,
  title: 'Concurrentes y Rotantes',
  desc: 'Entendé lo que ves y diferenciate desde el día uno.'
}, {
  icon: BookOpen,
  title: 'Preparación Concurso',
  desc: 'Razonamiento clínico que te destaca en la evaluación.'
}];
export function ForWho() {
  return <section className="py-8 md:py-20 bg-white" data-id="element-126">
      <div className="max-w-5xl mx-auto px-4" data-id="element-127">
        <div className="text-center mb-6 md:mb-12" data-id="element-128">
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1.5" data-id="element-129">
            ¿PARA QUIÉN ES?
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-130">
            Diseñado para vos
          </h3>
          <p className="text-gray-600 text-xs md:text-base" data-id="element-131">
            Si querés entrar a guardia con otra cabeza
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-2.5 md:gap-6 mb-5 md:mb-10" data-id="element-132">
          {targets.map((target, idx) => {
          const Icon = target.icon;
          return <div key={idx} className="bg-brand-dark text-white p-3 md:p-7 rounded-xl md:rounded-2xl flex flex-col md:flex-row items-start gap-2 md:gap-4 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 cursor-pointer group relative overflow-hidden" data-id="element-133">
                <div className="absolute top-0 right-0 w-20 h-20 bg-brand-cta/0 group-hover:bg-brand-cta/10 rounded-full blur-2xl transition-all duration-500" data-id="element-134"></div>
                <div className="bg-brand-cta/15 p-2 md:p-3 rounded-lg md:rounded-xl shrink-0 group-hover:bg-brand-cta/25 transition-colors" data-id="element-135">
                  <Icon className="w-4 h-4 md:w-7 md:h-7 text-brand-cta" data-id="element-136" />
                </div>
                <div className="min-w-0 flex-1" data-id="element-137">
                  <h4 className="font-bold text-[13px] md:text-lg mb-0.5 md:mb-2 leading-tight" data-id="element-138">
                    {target.title}
                  </h4>
                  <p className="text-gray-300 text-[11px] md:text-sm leading-snug line-clamp-2 md:line-clamp-none" data-id="element-139">
                    {target.desc}
                  </p>
                </div>
                <ArrowRight className="hidden md:block w-5 h-5 text-brand-cta opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all self-center" data-id="element-140" />
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-141">
          <p className="text-xs md:text-base text-gray-500 font-medium" data-id="element-142">
            ¿No estás seguro?{' '}
            <span className="text-brand-dark font-bold" data-id="element-143">
              Tenés 7 días de garantía.
            </span>
          </p>
        </div>
      </div>
    </section>;
}